import { memo } from "react";
import FlameIcon from "./images/icons/flame.svg?react";
import FlameBigLeftIcon from "./images/icons/flame-big-left.svg?react";
import FlameBigRightIcon from "./images/icons/flame-big-right.svg?react";
import "./BlackFridayTheme.scss";

const BlackFridayTheme = memo(() => {
  return (
    <>
      <div className="flameLeft">
        <FlameIcon className="flameLeftIcon" />
      </div>
      <div className="middleFlames">
        <div className="flameBackLeft">
          <FlameBigLeftIcon className="flameBackLeftIcon" />
        </div>
        <div className="middleFlameLeft">
          <FlameIcon className="middleFlameLeftIcon" />
        </div>
        <div className="middleFlameRight">
          <FlameIcon className="middleFlameRightIcon" />
        </div>
        <div className="flameBackRight">
          <FlameBigRightIcon className="flameBackRightIcon" />
        </div>
      </div>
      <div className="flameRight">
        <FlameIcon className="flameRightIcon" />
      </div>
    </>
  );
});

export default BlackFridayTheme;
